export const userTableColumns = [
  { key: "username", value: "Username" },
  { key: "fullName", value: "Full Name" },
  { key: "email", value: "Email" },
  { key: "role", value: "Role" },
  { key: "active", value: "Active" },
  { key: "actions", value: "" },
];
